import { Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import React from "react";
import { LoadingOverlay } from "../../../components/LoadingOverlay/LoadingOverlay";
import getMe from "../../../graphql/auth/getMe";
import anyLoading from "../../../utils/anyLoading";
import { Page } from "../../../components/Page";
import PageHeader from "../../../components/PageHeader";
import { checkIsAdmin } from "../../../utils/checkIsAdmin";
import { GroupMemberListContent } from "../GroupMemberList/GroupMemberList";
import { checkIsPrimaryPayer } from "../../../utils/checkIsPrimaryPayer";
import NotAuthorised from "../../NotAuthorised/NotAuthorised";

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(3)
    },
    results: {
        marginTop: theme.spacing(3)
    }
}));

const MyTravellersList = () => {
    const classes = useStyles();
    const meData = getMe();
    const loadingData = anyLoading(meData);
    const title = "My Travelers";

    const isAdmin = checkIsAdmin(false);
    const isCheckIsPrimaryPayer = checkIsPrimaryPayer();

    return (
        <React.Fragment>
            <LoadingOverlay loading={loadingData.loading}>
                {meData.data && meData.data.me && (
                    <React.Fragment>
                        {isAdmin || isCheckIsPrimaryPayer ? (
                            <Page className={classes.root} title={title}>
                                <PageHeader section="groups" title={title} />
                                <GroupMemberListContent
                                    isAdmin={isAdmin}
                                    canEdit={false}
                                />
                            </Page>
                        ) : (
                            <NotAuthorised />
                        )}
                    </React.Fragment>
                )}
            </LoadingOverlay>
        </React.Fragment>
    );
};

export default MyTravellersList;
